const consts  = {
    serviceUrl: __SERVICE_URL__,
    clientName: __CLIENT_NAME__,
    projectName: __PROJECT_NAME__,
    basePath: __BASE_PATH__,
    cdnPath: __CDN_PATH__,
}

export default consts;